import { Col, Form, Row } from "antd";
import FormItem from "antd/lib/form/FormItem";
import React, {forwardRef,useImperativeHandle } from "react";
import regexMap from "../../utils/regexMap";
import {
    ErrFormItem, InputWrapper, PhoneLabelWrap, RowWrapper, TitleMarginTop, TitleWrapper, WrapLabel,CheckWrap
} from "../commonStyles";
import { InputField,CustomCheckbox } from "../commonStyles";


export const  getInitValue = (phone = [],type)=>{
    if(type === "checkbox")
    {
       const primaryPhoneNumber  = phone.find((phn)=>(phn.phonetype === "Primary"));
       const mobilePhoneNumber  = phone.find((phn)=>(phn.phonetype === "Mobile"));
       if(primaryPhoneNumber && mobilePhoneNumber)
       {
        return  (primaryPhoneNumber.phonenumber&&mobilePhoneNumber.phonenumber)? primaryPhoneNumber.phonenumber === mobilePhoneNumber.phonenumber :false
           
       }

       return false

    }
    else
    {
   return  phone.reduce((acc, phn) => {
        if (phn.phonetype === type) {
            acc = phn.phonenumber
        }
        return acc;
    }, null)
}
}


const  PhoneForm =  forwardRef(({phone = [], disabled = false, form, elementIds }, ref)=> {

    const {getFieldDecorator, getFieldsValue, setFieldsValue, validateFields } = form;

    let elmID = {
        primary: 'primary',
        mobile: 'mobile',
        other: "other",
        checkbox: 'checkbox'
    }

    if(elementIds) {
        elmID = elementIds;
    }

    useImperativeHandle(ref, () => ({
        form      
    }));     

    return (
        <RowWrapper>
            <PhoneLabelWrap>Phone</PhoneLabelWrap>
            <div>
                <Row gutter={24}>
                    <Col lg={{ span: 7 }} md={{ span: 9 }}>
                        <WrapLabel>
                            <>
                                <FormItem
                                    colon={false}
                                    label={
                                        <TitleMarginTop>
                                            <TitleWrapper>Primary Phone Number</TitleWrapper>
                                        </TitleMarginTop>
                                    }
                                    data-test="primary-phone"
                                >
                                    <InputWrapper>
                                        {getFieldDecorator(elmID.primary, {
                                            rules: [
                                                {
                                                    pattern:regexMap.phoneWithCharacters,
                                                    required:true,
                                                    message: <ErrFormItem>Please enter phone number</ErrFormItem>                                                
                                                }
                                            ],
                                            validateTrigger: ["onChange", "onBlur", 'onSubmit'],
                                            initialValue:getInitValue(phone,"Primary")                                            
                                        })(
                                            <InputField                                                
                                                className="remove_error_style"
                                                disabled={disabled}
                                                aria-label="Enter phone number"
                                                placeholder="Enter phone number"
                                                data-test="primary-phone-input"
                                                onBlur={(e)=>{
                                                    let vals = getFieldsValue([elmID.mobile, elmID.checkbox, elmID.primary]);
                                                    if(vals[elmID.checkbox])
                                                    {
                                                        setFieldsValue({
                                                            [elmID.mobile]: vals[elmID.primary]                                                            
                                                        })
                                                    }

                                
                                                }}
                                            />

                                        )}                                        
                                    </InputWrapper>
                                </FormItem>
                            </>
                        </WrapLabel>
                    </Col>
                    <Col lg={{ span: 7 }} md={{ span: 9 }}>
                                    <FormItem 
                                            colon={false}
                                    data-test="primary-phone-checkbox"
                                    label={
                                        <div className="test"></div>
                                    }
                                    >
                    <TitleMarginTop>&nbsp;</TitleMarginTop>
                    <InputWrapper>

                    {
                        getFieldDecorator(elmID.checkbox, {
                            initialValue:getInitValue(phone,"checkbox"),
                            valuePropName:"checked"
                        })
                    (<CustomCheckbox data-test="sameAddrCheckBox" className="checkboxMarginTop" onChange={(e)=>{
                         let vals = getFieldsValue([elmID.mobile, elmID.checkbox, elmID.primary]);                         
                       if((!e.target.checked) && vals[elmID.mobile])
                       {
                        setFieldsValue({
                            [elmID.mobile]: null                            
                        })
                       }else 
                       {
                            validateFields((err,values)=>{                                
                                if(err)
                                {
                                    setFieldsValue({
                                        [elmID.checkbox]: false                                        
                                    });

                                }else
                                {
                                    setFieldsValue({
                                        [elmID.mobile]: values[elmID.primary]                                        
                                    })
                                }
                            })
                       }

                    }} disabled = {disabled}>
                               <CheckWrap>Is this your mobile phone number?</CheckWrap>
                    </CustomCheckbox>)
                    }
                    </InputWrapper>
                    </FormItem>
                    </Col>
                    
                </Row>
                <Row gutter={24}>
                    <Col lg={{ span: 7 }} md={{ span: 9 }}>
                        <WrapLabel>
                            <>
                            <FormItem
                                    colon={false}
                                    label={
                                        <TitleMarginTop>
                                            <TitleWrapper>Mobile Phone Number (optional)</TitleWrapper>
                                        </TitleMarginTop>
                                    }
                                    data-test="mobile-phone"
                                >
                                    <InputWrapper>
                                        {getFieldDecorator(elmID.mobile, {

                                            validateTrigger: ["onChange", "onBlur"],
                                            initialValue: getInitValue(phone,"Mobile")
                                         
                                        })(
                                            <InputField
                                                aria-label="phone number"
                                                placeholder="Enter phone number"
                                                disabled={disabled}
                                                data-test = "mobile-input"
                                                onBlur={(e)=>{
                                                    let vals = getFieldsValue([elmID.mobile, elmID.checkbox, elmID.primary]);                                                    
                                                    if(vals[elmID.checkbox] && vals[elmID.primary])
                                                    {

                                                        if(vals[elmID.primary] !== vals[elmID.mobile])
                                                        {
                                                            setFieldsValue({
                                                                [elmID.checkbox]: false                                                           
                                                            })
                                                        }
                                                    }
                                                }}
                                            />
                                        )}
                                    </InputWrapper>
                                </FormItem>
                              
                            </>
                        </WrapLabel>

                    </Col>

                    <Col lg={{ span: 7 }} md={{ span: 9 }}>
                        <WrapLabel>
                            <>
                            <FormItem
                                    colon={false}
                                    label={
                                        <TitleMarginTop>
                                            <TitleWrapper>Other Phone Number (optional)</TitleWrapper>
                                        </TitleMarginTop>
                                    }
                                    data-test="other-phone"
                                >
                                    <InputWrapper>
                                        {getFieldDecorator(elmID.other, {
                                            validateTrigger: ["onChange", "onBlur"],
                                            initialValue: getInitValue(phone,"Other")

                                        })(

                                            <InputField
                                                aria-label="phone number"
                                                placeholder="Enter phone number"
                                                disabled={disabled}
                                            />
                                        )}
                                    </InputWrapper>
                                </FormItem>
                            </>
                        </WrapLabel>
                    </Col>
                </Row>
            </div>

        </RowWrapper>
    );

})



 const WrappedPhoneForm = Form.create({ onValuesChange(props, changedValues, value) {
    const { elementIds } = props;
    const primary = elementIds ? value[elementIds.primary]: value['primary'];
    const mobile = elementIds ? value[elementIds.mobile]: value['mobile'];
    const other = elementIds ? value[elementIds.other]: value['other']; 
    const checkbox = elementIds ? value[elementIds.checkbox]: value['checkbox']; 
    if(!(changedValues.hasOwnProperty(elementIds?.checkbox)||changedValues.hasOwnProperty("checkbox")))
    {

        if((primary&&mobile) &&(primary === mobile))
        {
            props.form.setFieldsValue({
              ...(elementIds?{[elementIds.checkbox]:true}:{"checkbox":true})  
            })
        }
        else if(checkbox&&(changedValues.hasOwnProperty(elementIds?.mobile)||changedValues.hasOwnProperty("mobile")))
        {
            props.form.setFieldsValue({
                ...(elementIds?{[elementIds.checkbox]:false}:{"checkbox":false})  
              })
        }
    }
    if(props.handleChange)
    {
        props.handleChange( {
            phone: [{
                phonetype:"Primary",
                phonenumber:primary
            },...(!!other?[{phonetype:"Other",phonenumber:other}]:[{phonetype:"Other",phonenumber:""}]),...(!!mobile?[{phonetype:"Mobile",phonenumber:mobile}]:[{phonetype:"Mobile",phonenumber:""}])]
        })
    }
} })(PhoneForm);



export default WrappedPhoneForm;